import { render, staticRenderFns } from "./indexStudent.vue?vue&type=template&id=f4d3e826&scoped=true"
import script from "./indexStudent.vue?vue&type=script&lang=js"
export * from "./indexStudent.vue?vue&type=script&lang=js"
import style0 from "./indexStudent.vue?vue&type=style&index=0&id=f4d3e826&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d3e826",
  null
  
)

export default component.exports